import { getApiUrl } from './apiConfig';

export const fetchEnrolledStudents = async () => {
  try {
    const response = await fetch(getApiUrl('enrolled-students'));
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching enrolled students:', error);
    return null;
  }
};
